import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  root: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: designTokens.spacing[8],
    backgroundColor: projectIqTokens.bg,
    minHeight: 0,
  },

  unavailableBanner: {
    maxWidth: "560px",
    marginBottom: designTokens.spacing[8],
  },

  wordmark: {
    fontFamily: projectIqTokens.fontFamily,
    fontSize: designTokens.fontSize["4xl"],
    fontWeight: designTokens.fontWeight.bold,
    lineHeight: designTokens.lineHeight.tight,
    letterSpacing: "-0.02em",
    margin: 0,
    marginBottom: designTokens.spacing[4],
  },

  wordmarkProject: {
    color: projectIqTokens.ink,
  },

  wordmarkIq: {
    color: projectIqTokens.teal,
  },

  subheading: {
    fontFamily: projectIqTokens.fontFamily,
    fontSize: designTokens.fontSize["2xl"],
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink,
    margin: 0,
    marginBottom: designTokens.spacing[3],
    textAlign: "center",
  },

  body: {
    fontFamily: projectIqTokens.fontFamily,
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.normal,
    color: projectIqTokens.muted,
    textAlign: "center",
    maxWidth: "440px",
    lineHeight: designTokens.lineHeight.relaxed,
    margin: 0,
    marginBottom: designTokens.spacing[6],
  },

  ctaButton: {
    fontFamily: projectIqTokens.fontFamily,
    backgroundColor: projectIqTokens.tealInk,
    fontWeight: designTokens.fontWeight.semibold,
    height: "40px",
    paddingLeft: designTokens.spacing[5],
    paddingRight: designTokens.spacing[5],
    ":hover:not(:disabled)": {
      backgroundColor: projectIqTokens.teal,
    },
    ":active:not(:disabled)": {
      backgroundColor: projectIqTokens.tealInk,
    },
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.ink}`,
      outlineOffset: "2px",
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
    },
  },
});
